import React from "react";
import { basicInfoFieldConfig } from "../institute.config";
import { useTranslation } from "react-i18next";
import type { BasicInfo } from "../types/types";

interface BasicInfoStepProps {
	data?: BasicInfo;
}

const BasicInfoStep: React.FC<BasicInfoStepProps> = ({ data }) => {
	const { t } = useTranslation();

	// Use provided data or fallback to default config
	const fieldConfig = basicInfoFieldConfig.map(field => ({
		...field,
		value: data?.[field.name as keyof BasicInfo]?.toString() || "N/A",
	}));

	return (
		<div className="space-y-4 p-2">
			<div className="text-xl font-semibold text-gray-800">{t("components.instituteDetails.basicInfo.title")}</div>
			<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
				{fieldConfig?.map(field => (
					<div
						key={field.name}
						className="flex items-center gap-3 p-2 rounded-lg bg-white border border-gray-200 hover:border-gray-300 transition-all duration-200 shadow-sm hover:shadow-md">
						<div className="flex-shrink-0 w-8 h-8 bg-gray-400 rounded-lg flex items-center justify-center shadow-sm">
							<div className="text-white text-base drop-shadow-sm">{field.icon}</div>
						</div>
						<div className="flex-1 min-w-0">
							<div className="text-sm font-semibold text-gray-900 tracking-wide mb-1">
								{field.label}
								<span className="text-red-500 ml-1">*</span>
							</div>
							<div className="text-sm font-medium text-gray-500 truncate">{field.value}</div>
						</div>
					</div>
				))}
			</div>
		</div>
	);
};

export default BasicInfoStep;
